// extracted by mini-css-extract-plugin
export default {"control":"control_control__+rqHW","button":"control_button__tTlhw"};